/// <reference types="./AdminEntityMutationUtils.d.ts" />
import { getEntityNameBase, notOk, ok, } from '@dossierhq/core';
export function randomNameGenerator(name) {
    const nameBase = getEntityNameBase(name);
    return `${nameBase}#${Math.random().toFixed(8).slice(2)}`;
}
export function checkUUIDsAreUnique(references) {
    const unique = new Set();
    for (const { id } of references) {
        if (unique.has(id)) {
            return notOk.BadRequest(`Duplicate ids: ${id}`);
        }
        unique.add(id);
    }
    return ok(undefined);
}
//# sourceMappingURL=AdminEntityMutationUtils.js.map